module.exports = __webpack_public_path__ + "img/insights.214aeed3.png";